module.exports = __webpack_public_path__ + "img/192-0df834.png";